import { Field } from 'redux-form';
import RankingInput from './RankingInput';

const RankingField = (props) => {
  return <Field name={props.name} component={RankingInput} {...props} />;
}

export default RankingField;
